import { Outlet, Route, Routes } from 'react-router-dom'
import { ProtectedRoute } from '@/components/auth'
import { Layout } from '@/components/layout'
import {
  AuthCallbackPage,
  BooksPage,
  ChallengePage,
  ClubPage,
  ClubsPage,
  DashboardPage,
  DigitalShelfPage,
  JoinClubPage,
  LandingPage,
  LoginPage,
  NotesPage,
  PrivacyPolicy,
  ResetPasswordPage,
  RouletteCreatePage,
  RouletteHistoryPage,
  RouletteListPage,
  RouletteProgressPage,
  RouletteSpinPage,
  SettingsPage,
  TermsOfService,
  WishlistBooksPage,
  YearInReviewPage,
} from '@/pages'
import { BillingPage } from '@/pages/BillingPage'

// Layout wrapper that uses Outlet for nested routes
function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <Layout>
        <Outlet />
      </Layout>
    </ProtectedRoute>
  )
}

export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />

      {/* Landing page */}
      <Route path="/" element={<LandingPage />} />

      {/* Protected routes with shared layout */}
      <Route path="/dashboard" element={<ProtectedLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="books" element={<BooksPage />} />
        <Route path="digital-shelf" element={<DigitalShelfPage />} />
        <Route path="wishlist" element={<WishlistBooksPage />} />
        <Route path="notes" element={<NotesPage />} />
        <Route path="clubs">
          <Route index element={<ClubsPage />} />
          <Route path="join/:token" element={<JoinClubPage />} />
          <Route path=":clubId" element={<ClubPage />} />
          <Route path=":clubId/challenges/:challengeId" element={<ChallengePage />} />
        </Route>
        <Route path="year-in-review" element={<YearInReviewPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="settings/:section" element={<SettingsPage />} />
        <Route path="roulette">
          <Route index element={<RouletteListPage />} />
          <Route path="create" element={<RouletteCreatePage />} />
          <Route path=":id" element={<RouletteProgressPage />} />
          <Route path=":id/spin" element={<RouletteSpinPage />} />
          <Route path=":id/history" element={<RouletteHistoryPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
